import { Helmet } from "react-helmet";
import styles from "../styles/Home.module.scss";
import BannerImage from "../components/BannerImage";
import Carousel from "../components/Carousel";
import Button from "../components/Button";
import Counter from "../components/Counter";
import homeTile1 from "../assets/images/tile-images/home-tile-1.png";
import homeTile2 from "../assets/images/tile-images/Community-Driven-Solutions.jpg";
import homeTileImpact from "../assets/images/tile-images/in-class-training.jpeg";
import homeTileHearingFromWomen from "../assets/images/carousel-images/carousel-slide-new.jpg";
import { homeBannerData } from "../utils/bannerData/bannerData";
import S3CLink from "../components/S3CLink";

const Home = () => {
  return (
    <>
      <Helmet>
        <title>Strengthening Systems for Safer Childbirth</title>
      </Helmet>
      <BannerImage data={homeBannerData} />
      <div className={styles.homeStatHeader}>
        <p>Within 3 years</p>
      </div>
      <div className={styles.homeStatBar}>
        <div className={styles.homeStat}>
          <p className={styles.homeStatNumber}>
            <Counter number={4} />
          </p>
          <p className={styles.homeStatText}>Countries Engaged</p>
        </div>
        <div className={styles.homeStat}>
          <p className={styles.homeStatNumber}>
            <Counter number={20} />
          </p>
          <p className={styles.homeStatText}>Collaborators Activated</p>
        </div>
        <div className={styles.homeStat}>
          <p className={styles.homeStatNumber}>
            $<Counter number={25} />M
          </p>
          <p className={styles.homeStatText}>Committed</p>
        </div>
        {/* <div className={styles.homeStat}>
          <p className={styles.homeStatNumber}>
            <Counter number={1} />M+
          </p>
          <p className={styles.homeStatText}>women to be reached by 2025</p>
        </div> */}
      </div>
      <div className={`${styles.homeStatBar} ${styles.homeStatBarSecond}`}>
        <div className={styles.homeStat}>
          <p className={styles.homeStatNumber}>
            <Counter number={2.7} />M
          </p>
          <p className={styles.homeStatText}>
            People Reached with
            <br />
            improved access to
            <br />
            quality maternal
            <br />
            health services
          </p>
        </div>
        <div className={styles.homeStat}>
          <p className={styles.homeStatNumber}>
            <Counter number={8} />K
          </p>
          <p className={styles.homeStatText}>
            Health care
            <br />
            providers trained
          </p>
        </div>
        <div className={styles.homeStat}>
          <p className={styles.homeStatNumber}>
            <Counter number={475} speed={2} />
          </p>
          <p className={styles.homeStatText}>
            Health facilities
            <br />
            strengthened
          </p>
        </div>
        {/* <div className={styles.homeStat}>
          <p className={styles.homeStatNumber}>
            <Counter number={1} />M+
          </p>
          <p className={styles.homeStatText}>women to be reached by 2025</p>
        </div> */}
      </div>

      <div className={`${styles.homeBanner}`}>
        <p>
          The Strengthening Systems for Safer Childbirth initiative concluded in December 2025 after supporting locally led
          efforts to improve maternal health across India, Kenya, Nigeria, and Sierra Leone. This website serves as a
          repository to share the initiative's stories, resources, and lessons learned, with the hope that they continue to
          inform and inspire future efforts to strengthen maternal health systems.
        </p>
      </div>

      {/* <div className={`${styles.homeTileSection} ${styles.blueBg} ${styles.whiteColor}`}> */}
      {/* <div className={styles.homeTileSection}>
        <div className={`${styles.homeTileLarge} ${styles.homeTextTile}`}>
          <div className={styles.homeTileContent}>
            <h2 className={styles.homeTileTitle}>
            Year in review
            </h2>
            <p className={styles.homeTileBody}>
            One year ago, MSD for Mothers (MfM) announced a bold new $25M initiative, Strengthening Systems for Safer Childbirth, that set out to pick up the pace in saving women’s lives and achieve Sustainable Development Goals targets to reduce maternal mortality. To accelerate action, MfM focused on fostering community led solutions tapping into underutilized private sector innovations. Six coalitions representing twenty collaborators across four countries - India, Nigeria, Kenya and Sierra Leone - came on board to implement solutions based on the needs and preferences of the women in their communities. 
            </p>
           
            <S3CLink href='/what-we-do' internal>
              <Button variant='primary'>LEARN MORE</Button>
            </S3CLink>
          </div>
        </div>
        <div className={styles.homeTileSmall}>
          <img
            className={styles.homeTileImage}
            src={homeTile1}
            alt='Woman carrying sleeping baby on back.'
          />
        </div>
      </div> */}

      <div className={styles.homeTileSection}>
        <div className={styles.homeTileSection}>
          <div className={`${styles.homeTileSmall} ${styles.homeTextTile} ${styles.homeTileSwitch}`}>
            <div className={styles.homeTileContent}>
              <h2 className={styles.homeTileTitle}>Hearing from Women and Health Providers</h2>
              <p className={styles.homeTileBody}>
                Read about how 60 Decibels, a social impact measurement company, surveyed 1500+ women and 600+ health care
                providers about their experience participating in the initiative.
              </p>
              <S3CLink href="/60db_ImpactReport_ExecutiveSummary.pdf">
                <Button variant="primary">LEARN MORE</Button>
              </S3CLink>
            </div>
          </div>
          <div className={`${styles.homeTileLarge} ${styles.homeTileSwitch}`}>
            <img className={styles.homeTileImage} src={homeTileHearingFromWomen} alt="Woman talking to doctor." />
          </div>
          <div className={styles.homeTileSmall}>
            <img className={styles.homeTileImage} src={homeTile2} alt="Woman carrying sleeping baby on back." />
          </div>
          <div className={`${styles.homeTileLarge} ${styles.homeTextTile}`}>
            <div className={styles.homeTileContent}>
              <h2 className={styles.homeTileTitle}>
                Community-Driven Solutions to Improve the Quality of Maternal Health Care
              </h2>
              <p className={styles.homeTileBody}>
                Read a report examining how our coalitions across India, Kenya, Nigeria and Sierra Leone helped tackle
                complex maternal health challenges and delivered results.
              </p>
              <S3CLink
                href="https://www.msdformothers.com/docs/MSD-for-Mothers-Strengthening-Systems-for-Safer-Childbirth-Report.pdf"
                internal
              >
                <Button variant="primary">LEARN MORE</Button>
              </S3CLink>
            </div>
          </div>
        </div>
        <div className={`${styles.homeTileSmall} ${styles.homeTextTile} ${styles.homeTileSwitch}`}>
          <div className={styles.homeTileContent}>
            <h2 className={styles.homeTileTitle}>Measuring Impact Across the Coalitions</h2>
            <p className={styles.homeTileBody}>
              60 Decibels (60 dB), a global impact measurement company, evaluated how Strengthening Systems for Safer
              Childbirth impacts the initiatives key stakeholders: women and providers. Leveraging their network of
              researchers, 60 dB conducted interviews in local languages to gather insights from the communities each
              coalition serves. Their human-centered approach delivered reliable and actionable data that highlights key
              drivers of success, identified areas of improvement and surfaced valuable lessons learned – enabling the
              coalitions and the broader initiative to make evidence-based decisions that continuously improved the quality
              and reach of maternal health care services. Learn more about how we are leveraging the insights gathered to
              date to elevate women’s voices in maternal health.  
            </p>
            <S3CLink href="/measuring-impact-across-the-coalitions" internal>
              <Button variant="primary">LEARN MORE</Button>
            </S3CLink>
          </div>
        </div>
        <div className={`${styles.homeTileLarge} ${styles.homeTileSwitch}`}>
          <img className={styles.homeTileImage} src={homeTileImpact} alt="Woman carrying baby on back." />
        </div>
      </div>

      {/* <div className={`${styles.homeTileSection} ${styles.blueBg} ${styles.whiteColor}`}> */}
      <div className={styles.homeTileSection}>
        <div className={styles.homeTileSmall}>
          <img className={styles.homeTileImage} src={homeTile1} alt="Woman carrying sleeping baby on back." />
        </div>
        <div className={`${styles.homeTileLarge} ${styles.homeTextTile}`}>
          <div className={styles.homeTileContent}>
            <h2 className={styles.homeTileTitle}>Think Globally, Help Save Mothers Locally</h2>
            <p className={styles.homeTileBody}>
              Strengthening Systems for Safer Childbirth is a global initiative using locally-driven solutions to accelerate
              progress in helping save women’s lives. MSD for Mothers, working together with others, is supporting local
              coalitions to overcome the specific maternal health challenges in their communities, helping women have access
              to care to support healthier pregnancies and safer deliveries.
            </p>
            <S3CLink href="/what-we-do" internal>
              <Button variant="primary">LEARN MORE</Button>
              {/* <Button variant='primaryWhiteColor'>LEARN MORE</Button> */}
            </S3CLink>
          </div>
        </div>
      </div>

      <div className={styles.homeCarouselTile}>
        <h2 align="center">Project Highlights</h2>
      </div>

      <Carousel />
    </>
  );
};

export default Home;
